import { render, staticRenderFns } from "./FlightStats.vue?vue&type=template&id=765d8511&scoped=true"
import script from "./FlightStats.vue?vue&type=script&lang=js"
export * from "./FlightStats.vue?vue&type=script&lang=js"
import style0 from "./FlightStats.vue?vue&type=style&index=0&id=765d8511&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765d8511",
  null
  
)

export default component.exports